module.exports = __webpack_public_path__ + "static/media/03 Generali Ubezpieczenie upraw Ustandaryzowany dokument.dea09651.pdf";